import * as React from "react";
import { cn } from "../../lib/utils.ts";

export const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "bg-white/8 backdrop-blur-md border border-white/10 rounded-[--radius-card] shadow-2xl",
      className,
    )}
    {...props}
  />
));
Card.displayName = "Card";
